import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { lazy, Suspense } from "react";
import Navbar from "./Components/NewHeader/Navbar";
import Footer from "./Components/pages/Footer";
import NewFooter from "./Components/Footer/NewFooter";
import "bootstrap/dist/css/bootstrap.min.css";
import LazyRender from "./Components/LazyRender";
import NewActivityIndex from "./Components/pages/NewActivityIndex";

const NewHome = lazy(() => import("./Components/pages/NewHome"));
const AboutUs = lazy(() => import("./Components/AboutUs/About"));
const ScrollToTop = lazy(() => import("./Components/ScrollToTop/ScrollTo"));
const ActivityIndex = lazy(() => import("./Components/pages/ActivityIndex"));
const StCharbelVideoGallery = lazy(
  () =>
    import("./Components/pages/StCharbelVideoGallery/StCharbelVideoGallery"),
);
const StJosephVideoGallery = lazy(
  () => import("./Components/pages/StCharbelVideoGallery/StJosephVideoGallery"),
);
const NewsPage = lazy(() => import("./Components/pages/News/NewsPage"));
const NewsDetails = lazy(() => import("./Components/pages/News/NewsDetails"));
const GalleryCategories = lazy(
  () => import("./Components/pages/StJosephGallery/GalleryCategories"),
);
const GalleryDetails = lazy(
  () => import("./Components/pages/StJosephGallery/GalleryDetails"),
);

const Donate = lazy(() => import("./Components/pages/Donate"));
const Typing = lazy(() => import("./Components/pages/test/typing"));
const SpiritualStJospehGallery = lazy(
  () => import("./Components/pages/StJosephDownloads/StJosephDownloads"),
);
const SpiritualStCharbelGallery = lazy(
  () => import("./Components/pages/StCharbelDownloads/StCharbelDownloads"),
);
const DocumentDownloads = lazy(
  () => import("./Components/pages/DownloadsDocument"),
);
const ActivitiesGallery = lazy(
  () => import("./Components/pages/ActivitesPage/ActivitiesGallery"),
);
const MoreActivities = lazy(
  () => import("./Components/pages/ActivitesPage/FetchAllActivities"),
);

function App() {
  return (
    <Router>
      <Navbar />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<NewHome />} />
          {/* <Route path="/NewHome" element={<NewHome />} /> */}
          <Route path="/AboutUs" element={<AboutUs />} />
          {/* <Route path="/Activity" element={<ActivityIndex />} /> */}
          {/* <Route path="/Activity/:id" element={<ActivityIndex2 />} /> */}
          <Route path="/Activity/:id" element={<NewActivityIndex />} />
          <Route
            path="/ActivitiesGallery/:id"
            element={<ActivitiesGallery />}
          />
          <Route path="/MoreActivities" element={<MoreActivities />} />
          <Route
            path="/StCharbelVideoGallery"
            element={<StCharbelVideoGallery />}
          />
          <Route
            path="/StJosephVideoGallery"
            element={<StJosephVideoGallery />}
          />
          <Route path="/Downloads" element={<DocumentDownloads />} />
          <Route path="/NewsPage" element={<NewsPage />} />
          <Route path="/news/:id" element={<NewsDetails />} />
          <Route path="/mediagallery" element={<GalleryCategories />} />
          <Route path="/gallery" element={<GalleryCategories />} />
          <Route path="/gallery/:categoryId" element={<GalleryDetails />} />
          <Route path="/typing" element={<Typing />} />
          <Route
            path="/spiritualgallery"
            element={<SpiritualStJospehGallery />}
          />
          <Route
            path="/spiritualgallery-charbel"
            element={<SpiritualStCharbelGallery />}
          />
          <Route path="/typing" element={<Typing />} />
          <Route path="/donate" element={<Donate />} />
        </Routes>
        <ScrollToTop />
        <LazyRender>
          <Footer />
        </LazyRender>
      </Suspense>
    </Router>
  );
}

export default App;
